import { LocalStorageService } from "@hcworkspace/sysque/toolbelt/utils";
import { AnnotationSettingsReturnCodes } from "../models/annotation-settings-codes";
import { GlobalConstants } from "../constants/global-constants";

export class AnnotationSettingsReceiveController {
    constructor(private localStorageService: LocalStorageService) {}
    
    public ApplyDataResult(response: AnnotationSettingsReturnCodes): void {
        this.localStorageService.updateDispatchLocalStorage(GlobalConstants.ApplyDataResponse, JSON.stringify(response));
    }
}